import { cn } from '@latitude/token-utils';

import type { CardListItemProps } from './types';
import {
  cardListItemSubtitleVariants,
  cardListItemTitleVariants,
  cardListItemVariants,
} from './variants';

/**
 * CardListItem is a flexible list item for card layouts, supporting leading, title/subtitle, and trailing slots.
 */
const CardListItem = ({
  className,
  leading,
  title,
  subtitle,
  trailing,
  labelId,
  size,
  state,
  variant,
  children,
  'data-testid': dataTestId = 'card-list-item',
  ...rest
}: CardListItemProps) => {
  return (
    <div
      data-testid={dataTestId}
      className={cn(cardListItemVariants({ state, size, variant }), className)}
      {...rest}
    >
      {children ? (
        children
      ) : (
        <>
          {leading && (
            <div className="flex min-w-[24px] items-start">{leading}</div>
          )}
          <div className="flex min-w-0 flex-1 flex-col justify-center">
            {title && (
              <div
                id={labelId}
                className={cn(
                  cardListItemTitleVariants({
                    disabled: state === 'disabled',
                  }),
                )}
              >
                {title}
              </div>
            )}
            {subtitle && (
              <div
                id={title ? undefined : labelId}
                className={cn(
                  cardListItemSubtitleVariants({
                    disabled: state === 'disabled',
                  }),
                )}
              >
                {subtitle}
              </div>
            )}
          </div>
          {trailing && <div className="ml-4 flex items-center">{trailing}</div>}
        </>
      )}
    </div>
  );
};

CardListItem.displayName = 'CardListItem';

export { CardListItem };
